import { Pipe, PipeTransform } from '@angular/core';
import { titleCaseClean } from '@fleet/utilities';

@Pipe({ name: 'titleCaseAndClean' })
export class TitleCaseAndCleanPipe implements PipeTransform {
  transform(value: any, options?: any): any {
    return titleCaseClean(value, options);
  }
}
